import { useContext, useRef } from "react";
import { AppDispatchContext, CalculationActionTypes } from "../../state";
import { type BubbleType } from "../InfoBubbles";

const useScrollHighlight = () => {
  const dispatch = useContext(AppDispatchContext);

  const scrollTargetRefs = {
    employerPaidCostsRef: useRef<HTMLTableElement>(null),
    bikeSavingsRef: useRef<HTMLTableElement>(null),
    monthlyRateRef: useRef<HTMLDivElement>(null),
    individualSubsidyRef: useRef<HTMLInputElement>(null),
  };

  const scrollAndHighlight = (element: HTMLElement, cssClasses: string[]) => {
    setTimeout(() => {
      element.classList.add(...cssClasses);
      element.setAttribute("tabIndex", "-1");
      element.focus();

      setTimeout(() => {
        element.classList.remove(...cssClasses);
        element.removeAttribute("tabIndex");
      }, 2500);

      element.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  const bubbleClickHandler = (bubbleType: BubbleType) => {
    const ref = scrollTargetRefs[`${bubbleType}Ref`]?.current;

    const cssClasses = ["scroll-margin-top"];

    if (bubbleType === "monthlyRate") {
      dispatch({ type: CalculationActionTypes.SHOW_RESULTS_DETAILS, payload: true });
      cssClasses.push("highlight-fade-monthly-rate");
    } else {
      cssClasses.push("highlight-fade");
    }

    if (ref) {
      scrollAndHighlight(ref, cssClasses);
    }
  };

  const subsidyBoxClickHandler = () => {
    const ref = scrollTargetRefs.individualSubsidyRef.current;
    if (ref) {
      scrollAndHighlight(ref, ["scroll-margin-top"]);
    }
  };

  return { scrollTargetRefs, bubbleClickHandler, subsidyBoxClickHandler };
};

export { useScrollHighlight };
